// API Health Check Utility
export class ApiHealthChecker {
  private static instance: ApiHealthChecker
  private isHealthy: boolean = true
  private lastCheck: number = 0
  private checkInterval: number = 30000 // 30 seconds

  private constructor() {}

  public static getInstance(): ApiHealthChecker {
    if (!ApiHealthChecker.instance) {
      ApiHealthChecker.instance = new ApiHealthChecker()
    }
    return ApiHealthChecker.instance
  }

  public async checkApiHealth(): Promise<boolean> {
    const now = Date.now()
    
    // Only check if enough time has passed since last check
    if (now - this.lastCheck < this.checkInterval) {
      return this.isHealthy
    }

    try {
      // Test a simple API endpoint with timeout using AbortController
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 5000)
      
      const response = await fetch('/api/health', {
        method: 'GET',
        signal: controller.signal
      })
      
      clearTimeout(timeoutId)
      this.isHealthy = response.ok
      this.lastCheck = now
      return this.isHealthy
    } catch (error) {
      console.warn('API health check failed:', error)
      this.isHealthy = false
      this.lastCheck = now
      return false
    }
  }

  public isApiHealthy(): boolean {
    return this.isHealthy
  }

  public setApiHealthy(healthy: boolean): void {
    this.isHealthy = healthy
  }
}

export default ApiHealthChecker.getInstance()
